import { allFeaturesAtFalse, type Features } from './default'

export const features: Features = {
  ...allFeaturesAtFalse,
  header: {
    loggedInLogo: '/themes/current/images/aladin_farm_paddingless.svg',
    showDistributor: true,
  },
  home: {
    ...allFeaturesAtFalse.home,
    advantages: true,
    contactTechnicalSale: true,
  },
  certificates: {
    phyto: true,
    explosive: true,
  },
  contact: {
    mailTo: 'contact@aladin.farm',
    hubspot: {
      formId: 'a370cba5-c60b-4888-affb-44fdfb7aeca6',
      portalId: '5942000',
    },
  },
  newsletter: {
    hubspot: {
      formId: '811dd8c6-9c18-403d-80f5-256aabde44a8',
      portalId: '5942000',
    },
    showCard: true,
  },
  shoppingList: true,
  footer: {
    ...allFeaturesAtFalse.footer,
    social: {
      facebook: 'https://www.facebook.com/aladin.farm.legeniedelagriculture',
      linkedin: 'https://www.linkedin.com/company/aladinfarm/about/',
      x: 'https://twitter.com/AladinFarm',
      youtube: 'https://www.youtube.com/channel/UC4vTNr_d29yRv0j1ulZHung',
    },
  },
  pdp: {
    templateB2AGFeature: true,
    showOnlyMainImage: false,
    showSupplier: true,
    showSupplierUniverseLink: true,
    showBenefits: true,
    showCarouselSupplier: true,
  },
  checkoutV2: {
    displayRpd: true,
    displayMention: true,
    selectionByProducts: true,
  },
  platform: {
    name: 'Aladin.farm',
  },
  inLanguage: 'fr-FR',
  webSite: {
    name: "Aladin, plateforme agricole d'achat de biens et services",
    url: 'https://www.aladin.farm/',
    searchTargetUrl: 'https://www.aladin.farm/products?query={search_term_string}',
  },
}
